<template>
  <b-form-group>
    <h6 class="mb-1 font-size-md">
      <span
        v-if="required"
        class="text-danger ml-n1"
      >*</span>
      {{ $t("global.email") }}
    </h6>
    <b-form-input
      v-model="currentAnswer"
      class="w-100"
      :placeholder="$t('global.please-enter') + $t('global.email')"
      type="email"
      maxlength="100"
      :state="validateState"
    />
    <b-form-invalid-feedback :state="validateState">
      {{
        currentAnswer
          ? $t("global.please-enter-correct")
          : $t("global.please-enter-required")
      }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  props: {
    answer: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
    },
    editable: {
      type: Boolean,
    },
  },
  data() {
    return {
      validateState: undefined,
      shouldEdit: false,
    };
  },
  computed: {
    currentAnswer: {
      get() {
        return this.answer;
      },
      set(value) {
        this.$emit('update:answer', value);
      },
    },
  },
  watch: {
    currentAnswer() {
      this.validate();
    },
  },
  created() {
    if (!this.currentAnswer) {
      this.shouldEdit = true;
    }
  },
  methods: {
    validate() {
      if (this.required) {
        if (!this.currentAnswer) {
          this.validateState = false;
          return false;
        }
      }
      if (this.currentAnswer) {
        const emailRe = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!emailRe.test(this.currentAnswer)) {
          this.validateState = false;
          return false;
        }
      }
      this.validateState = true;
      return true;
    },
  },
};
</script>
